module.exports = __webpack_public_path__ + "img/2023_LTI_FeedBacks.fa87e27d.png";